export default {
  user: {},
  // 角色列表
  roles: [],
  // 所有校区列表
  allCampusList: [],
  // 全局操作校区列表
  globalCampusList: [],
  // 年级列表
  gradeList: [],
  // 全局学员状态字典
  studentsStatus: {
    0: '未收费',
    1: '在读',
    6: '曾就读',
    7: '停课',
    10: '休学',
    99: '无效',
    100: '退学',
  },
  // 全局学员到课状态字典
  studentsCourseStatus: {
    0: '未点名',
    1: '出勤',
    2: '迟到',
    3: '请假',
    4: '缺勤',
  },
  // 机构列表
  companyList: [],
  // 招生来源列表
  comeFromList: [],
  // 升级通知内容
  updateNotice: {},
};
